import { type ReactNode, forwardRef } from 'react';

import styles from './CardContentLayout.css';

type TCardContentLayoutProps = {
  price: ReactNode;
  geo: ReactNode;
  actions: ReactNode;
  description: ReactNode;
  labels: ReactNode;
  publisher: ReactNode;
  title: ReactNode;
  subtitle: ReactNode;
  promotion: ReactNode;
};

export const CardContentLayout = forwardRef<HTMLDivElement, TCardContentLayoutProps>(function ContentLayout(
  { title, subtitle, actions, geo, price, description, labels, publisher, promotion },
  ref,
): ReactNode {
  return (
    <div className={styles['content']} ref={ref}>
      <div className={styles['content__promotion']}>{promotion}</div>
      <div className={styles['content__title']}>{title}</div>
      <div className={styles['content__subtitle']}>{subtitle}</div>
      <div className={styles['content__labels']}>{labels}</div>
      <div className={styles['content__geo']}>{geo}</div>
      <div className={styles['content__price']}>{price}</div>
      <div className={styles['content__description']}>{description}</div>
      <div className={styles['content__actions']}>{actions}</div>
      <div className={styles['content__publisher']}>{publisher}</div>
    </div>
  );
});
